export default function Logo({ withWordmark = true, markSize = 30 }) {
  return (
    <span className="inline-flex items-center gap-3">
      <svg
        width={markSize}
        height={markSize}
        viewBox="0 0 40 40"
        fill="none"
        aria-hidden="true"
        style={{ filter: "drop-shadow(0 0 8px rgba(61,107,255,0.4))" }}
      >
        <rect x="2.5" y="2.5" width="35" height="35" rx="7" stroke="rgba(255,255,255,0.3)" strokeWidth="1.5" />
        <rect x="8" y="8" width="2" height="2" fill="rgba(255,255,255,0.35)" />
        <rect x="30" y="8" width="2" height="2" fill="rgba(255,255,255,0.35)" />
        <rect x="8" y="30" width="2" height="2" fill="rgba(255,255,255,0.35)" />
        <rect x="30" y="30" width="2" height="2" fill="rgba(255,255,255,0.35)" />
        <path d="M9 20h22" stroke="#3D6BFF" strokeWidth="2.5" strokeLinecap="round" />
        <path d="M20 9v22" stroke="#00E5FF" strokeWidth="2.5" strokeLinecap="round" />
        <circle cx="20" cy="20" r="2.6" fill="#ffffff" />
      </svg>
      {withWordmark && (
        <span className="text-[15px] font-semibold tracking-tight text-white">
          QPI Laboratories, <span className="text-zinc-400">Inc.</span>
        </span>
      )}
    </span>
  );
}
